
(function () {
  var KEY = "lezo_attribution";
  var TTL_DAYS = 30;
  var now = function () { return Date.now(); };

  function getStored() {
    try {
      var o = JSON.parse(localStorage.getItem(KEY) || "null");
      if (o && o.t && now() - o.t < TTL_DAYS * 864e5) return o;
    } catch (e) {}
    return null;
  }
  function store(data) {
    try { data.t = now(); localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }
  function params() {
    var p = {};
    try { new URLSearchParams(location.search).forEach(function (v, k) { p[k.toLowerCase()] = v; }); } catch (e) {}
    return p;
  }
  function refHost() {
    try {
      if (!document.referrer) return "";
      var h = new URL(document.referrer).hostname.replace(/^www\./, "");
      if (h && h !== location.hostname.replace(/^www\./, "")) return h; // тільки зовнішні
    } catch (e) {}
    return "";
  }
  function normalize(host) {
    if (!host) return "";
    if (/google\./.test(host)) return "google";
    if (/instagram\./.test(host)) return "instagram";
    if (/(facebook|fb\.me|l\.facebook)/.test(host)) return "facebook";
    if (/(t\.co|twitter|x\.com)/.test(host)) return "twitter";
    if (/tiktok\./.test(host)) return "tiktok";
    if (/youtube\.|youtu\.be/.test(host)) return "youtube";
    if (/bing\./.test(host)) return "bing";
    if (/pinterest\./.test(host)) return "pinterest";
    return host; 
  }

  var p = params(), current = null;
  if (p["utm_source"]) {
    current = { source: p["utm_source"], medium: p["utm_medium"] || "cpc", campaign: p["utm_campaign"] || "", referrer: refHost(), landing: location.pathname + location.search };
  } else {
    var r = normalize(refHost());
    if (r) current = { source: r, medium: "referral", campaign: "", referrer: refHost(), landing: location.pathname };
  }

  var stored = getStored(), attr;
  if (current) { attr = current; store(current); }
  else if (stored) { attr = stored; }
  else { attr = { source: "direct", medium: "", campaign: "", referrer: "", landing: location.pathname }; store(attr); }

  var attrs = {
    traffic_source: attr.source || "direct",
    traffic_medium: attr.medium || "",
    traffic_campaign: attr.campaign || "",
    traffic_referrer: attr.referrer || "",
    landing_page: attr.landing || ""
  };
  var payload = JSON.stringify(attrs);
  try { if (sessionStorage.getItem("lezo_attr_last") === payload) return; } catch (e) {}

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: attrs })
  }).then(function () {
    try { sessionStorage.setItem("lezo_attr_last", payload); } catch (e) {}
  }).catch(function () {});
})();